// extracted by mini-css-extract-plugin
export default {"note-name":"NoteName-module__note-name___wLTqo"};